import { ArraysOfObjects, PrivilegesConstants } from "@core/user";
import isEqual from "fast-deep-equal";
import { Locales } from "../../strings/Locales.js";
import { granularPrivilegesIds, noAccess } from "./PrivilegesTableConstants.js";
/**
 * Converts to SCREAM_CASE
 */ var scream = function() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return parts.filter(Boolean).map(function(s) {
        return s.toUpperCase();
    }).join("_");
};
var getRowId = function(privilege) {
    return scream(privilege.targetDomain, privilege.owner, privilege.level);
};
var getPrivilegeName = function(privilege) {
    return Locales.formatOrHumanize("PrivilegesRows.".concat(privilege.targetDomain), {
        defaultTranslation: privilege.targetDomain
    });
};
var getPrivilegeTabName = function(privilege) {
    return Locales.formatOrDefault("PrivilegesTabs.".concat(getRowId(privilege)), {
        defaultTranslation: Locales.formatOrHumanize("PrivilegesTabs.".concat(scream(privilege.owner, privilege.level)), {
            defaultTranslation: privilege.owner
        })
    });
};
var getRowsFromPrivileges = function(param) {
    var _systemPrivileges = param.systemPrivileges, systemPrivileges = _systemPrivileges === void 0 ? noAccess : _systemPrivileges, _availablePrivileges = param.availablePrivileges, availablePrivileges = _availablePrivileges === void 0 ? noAccess : _availablePrivileges, _initialPrivileges = param.initialPrivileges, initialPrivileges = _initialPrivileges === void 0 ? noAccess : _initialPrivileges, _exclusivePrivileges = param.exclusivePrivileges, exclusivePrivileges = _exclusivePrivileges === void 0 ? noAccess : _exclusivePrivileges;
    var availablePrivilegesById = groupPrivilegesByRowId(availablePrivileges);
    var initialPrivilegesById = groupPrivilegesByRowId(initialPrivileges);
    var exclusivePrivilegesById = groupPrivilegesByRowId(exclusivePrivileges);
    return Object.values(systemPrivileges.reduce(function(rowsById, privilege) {
        var rowId = getRowId(privilege);
        if (!rowsById[rowId]) {
            rowsById[rowId] = {
                id: rowId,
                name: getPrivilegeName(privilege),
                tab: getPrivilegeTabName(privilege),
                owner: privilege.owner,
                targetDomain: privilege.targetDomain,
                level: privilege.level,
                systemPrivileges: [
                    privilege
                ],
                availablePrivileges: availablePrivilegesById[rowId] || noAccess,
                exclusivePrivileges: exclusivePrivilegesById[rowId] || noAccess,
                initialPrivileges: initialPrivilegesById[rowId] || noAccess
            };
        } else {
            rowsById[rowId].systemPrivileges.push(privilege);
        }
        return rowsById;
    }, {}));
};
var getTabsFromPrivileges = function(privileges) {
    return privileges ? Array.from(new Set(privileges.map(getPrivilegeTabName))).sort() : [];
};
var ref;
var groupPrivilegesByRowId = function(privileges) {
    return (ref = privileges === null || privileges === void 0 ? void 0 : privileges.reduce(function(privilegesByRowId, privilege) {
        var rowId = getRowId(privilege);
        if (!privilegesByRowId[rowId]) {
            privilegesByRowId[rowId] = [
                privilege
            ];
        } else {
            privilegesByRowId[rowId].push(privilege);
        }
        return privilegesByRowId;
    }, {})) !== null && ref !== void 0 ? ref : {};
};
var isGranularPrivilegeId = function(id) {
    return granularPrivilegesIds.includes(id);
};
var removeUndefinedProperties = function(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};
var isCreatePrivilege = function(privilege) {
    return privilege.type === "CREATE";
};
var hasChanged = function(initial, selected) {
    return !isEqual(initial, selected);
};
var getWarnings = function(param) {
    var selectedPrivileges = param.selectedPrivileges, initialPrivileges = param.initialPrivileges, availablePrivileges = param.availablePrivileges, exclusivePrivileges = param.exclusivePrivileges;
    var warnings = [];
    if (ArraysOfObjects.intersection(selectedPrivileges, PrivilegesConstants.potentPrivileges).length > 0) {
        warnings.push({
            type: "POTENT",
            affectedPrivileges: selectedPrivileges
        });
    }
    /**
     * Privileges that would cause the user to lock himself out if he saves the current selection.
     */ var unselectedExclusivePrivileges = ArraysOfObjects.difference(exclusivePrivileges, selectedPrivileges);
    if (unselectedExclusivePrivileges.length > 0) {
        warnings.push({
            type: "LOCKOUT",
            affectedPrivileges: unselectedExclusivePrivileges
        });
    }
    /**
     * Privileges that will be lost if the user saves the current selection.
     * Those privileges were already set on the resource but are not available for the user and were removed from the selection.
     * By lost we mean that the user will not be able to set them back himself.
     */ var privilegesLostIfSaved = ArraysOfObjects.difference(initialPrivileges, availablePrivileges, selectedPrivileges);
    if (privilegesLostIfSaved.length > 0) {
        warnings.push({
            type: "REDUCTION",
            affectedPrivileges: privilegesLostIfSaved
        });
    }
    return warnings;
};
export var PrivilegesTableUtils = {
    getRowsFromPrivileges: getRowsFromPrivileges,
    getTabsFromPrivileges: getTabsFromPrivileges,
    groupPrivilegesByRowId: groupPrivilegesByRowId,
    isGranularPrivilegeId: isGranularPrivilegeId,
    removeUndefinedProperties: removeUndefinedProperties,
    isCreatePrivilege: isCreatePrivilege,
    hasChanged: hasChanged,
    getWarnings: getWarnings,
    getRowId: getRowId
};

//# sourceMappingURL=PrivilegesTableUtils.js.map